// @flow
import React from 'react';
import imported from 'react-imported-component';
// import { useSelector } from 'react-redux';
// import { isBrowser } from '@finect/front-utils/isBrowser';
import { Applications } from '@finect/front-applications';
import { InterstitialWithTargeting } from '@finect/tabular-components/Ads';
import { ProductRequestModal } from '@finect/tabular-components/Products';
// import { help } from '../../configs/help';
import { LoginModal } from '../LoginModal';

// const Help = imported(() =>
//   import(/* webpackChunkName: "TC-Help" */ '@finect/tabular-components/Help').then(module => module.Help));

// const Conversations = imported(() => import(/* webpackChunkName: "TCO-App" */ '@finect/tabular-conversations/App'));

const FaviconMetatags = imported(() => import(/* webpackChunkName: "TCO-FaviconMetatags" */ '@finect/tabular-conversations/FaviconMetatags').then(module => module.FaviconMetatags));

// const user = useSelector(state => state.user.user);
const AppContextual = () => (
  <>
    <LoginModal />
    <ProductRequestModal Applications={Applications} />
    <FaviconMetatags />
    {/* <Help initialArticles={help} /> */}
    <InterstitialWithTargeting />
    {/* {user.isLoggedIn && isBrowser() ? <Conversations /> : null} */}
  </>
);
export default AppContextual;
